import { calculateTranslateVec } from './calculateTranslateVec'
import { translateObj } from './translateObj'

export const rotateGroup = (group, degree, edges) => {
  const translateVec = calculateTranslateVec(edges)
  translateObj(group, degree, translateVec)
}
